import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const SignUpSchema = Yup.object().shape({
    firstName: Yup.string()
        .matches(
            /^([a-zA-Z'-.]+ ?([a-zA-Z'-.]+)?)$/,
            'Enter your first name in format: John Smith'
        )
        .required('First name is required'),
    lastName: Yup.string()
        .required('Last name is required')
        .matches(
            /^([a-zA-Z'-.]+ ?([a-zA-Z'-.]+)?)$/,
            'Enter your last name in format: Martin Nero'
        ),
    email: Yup.string()
        .email('Invalid email')
        .required('Email is required')
        .max(256, 'Email can have a maximum of 256 characters'),
    password: Yup.string()
        .min(8, 'Password must be 8 characters at minimum!')
        .max(15, 'Password must be 15 characters at maximum!')
        .matches(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}/,
            'Password must contain uppercase, lowercase, number, special character and ranging from 8-15 characters'
        )
        .required('Password is required'),
    confirmPassword: Yup.string()
        .required('Confirm password is required')
        .oneOf(
            [Yup.ref('password'), null],
            'Password and Confirm Password should match'
        ),
});

/** @constant {ObjectShape} - Yup Object used for validationScheme in Login procedure */
const LoginSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email')
        .required('Email is required')
        .max(256, 'Email can have a maximum of 256 characters'),
    password: Yup.string().required('Password is required'),
});

/** @constant {ObjectShape} - Yup Object used for validationScheme in Forgot Password procedure */
const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email')
        .required('Email is required')
        .max(256, 'Email can have a maximum of 256 characters'),
});

/** @constant {ObjectShape} - Yup Object used for validationScheme in Reset Password procedure */
const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .min(8, 'Password must be 8 characters at minimum!')
        .max(15, 'Password must be 15 characters at maximum!')
        .matches(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}/,
            'Password must contain uppercase, lowercase, number, special character and ranging from 8-15 characters'
        )
        .required('Password is required'),
});

export { LoginSchema, ResetPasswordSchema, ForgotPasswordSchema, SignUpSchema };
